import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {

    const menuItems = <React.Fragment>
            <li className='hover:underline hover:underline-offset-8'><Link to='/' href='#home'>HOME</Link></li>
                <li className='hover:underline hover:underline-offset-8'><a href="#skill">SKILLS</a></li>
                <li className='hover:underline  hover:underline-offset-8'><a href="#project">PROJECTS</a></li>
                <li className='hover:underline  hover:underline-offset-8'><a href="#contact">CONTACT</a></li>
                <li className='hover:underline  hover:underline-offset-8'><a href="#project">PROJECTS</a></li>
                <li className='hover:underline  hover:underline-offset-8'><a href="#contact">CONTACT</a></li>
                <li className='hover:underline  hover:underline-offset-8'><Link to='/blogs'>BLOGS</Link></li>
    </React.Fragment>

    return (
        <nav className='flex flex-row-reverse lg:flex-row justify-between'>
            <div className='w-1/2 ml-10 p-2'>
                <h1 className='text-2xl font-bold text-green-400'> YAMIN</h1>
            </div>

            <div className="">

            <div className="dropdown lg:hidden">
      <label tabIndex={0} className="btn btn-ghost btn-circle">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h7" /></svg>
      </label>
      <ul tabIndex={0} className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52">
        {menuItems}
      </ul>
    </div>

    <ul className='lg:flex hidden gap-4 mr-10 text-lg p-2 text-blue-500 hover:cursor-pointer '>
                {menuItems}
            </ul>
            
  </div>


            
        </nav>
    );
};

export default Navbar;